import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-after-login-notifications',
  templateUrl: './after-login-notifications.page.html',
  styleUrls: ['./after-login-notifications.page.scss'],
})
export class AfterLoginNotificationsPage implements OnInit {
  url: string = '';
  isMultistep: boolean = false;

  currentStep: number = 0;
  totalSteps: number = 0;
  currentContent: SafeHtml;
  currentButtonLabel: string = '';
  currentButtonStyle: string = '';
  multistepData: any = null;
  acceptanceLabel: string = '';
  isAgreed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    this.url = this.route.snapshot.queryParams.url;

    if (localStorage.getItem('portal_settings')) {
      const settings = JSON.parse(localStorage.getItem('portal_settings'));
      const afterLogin = settings?.additional_settings?.after_login;
      if (
        afterLogin?.multistep_notification?.main_content?.textarea &&
        afterLogin?.after_login_allow_multistep === 'yes'
      ) {
        this.isMultistep = true;
        this.multistepData = afterLogin.multistep_notification;
        this.totalSteps = Object.keys(this.multistepData.multisteps || {}).length;
        this.loadStep(0);
      } else {
        this.finishAndGo();
      }
    } else {
      this.finishAndGo();
    }
  }

  private finishAndGo() {
    localStorage.setItem('is_login', '1');
    try {
      const settingsRaw = localStorage.getItem('portal_settings');
      if (settingsRaw) {
        const settings = JSON.parse(settingsRaw);
        const custom = settings?.additional_settings?.custom_notifications;
        const hasTermsOrAfter = !!(
          (custom?.after_login && custom.after_login !== '') ||
          (custom?.terms_conditions && custom.terms_conditions !== '')
        );

        if (hasTermsOrAfter) {
          this.router.navigate(['/login/terms'], { queryParams: { url: this.url } });
          return;
        }
      }
    } catch {}

    localStorage.setItem('remote_token', this.authService.remote_token);
    this.router.navigateByUrl('.' + this.url);
  }

  loadStep(stepNumber: number) {
    if (stepNumber === 0) {
      const mainContent = this.multistepData.main_content;
      this.currentContent = this.sanitizer.bypassSecurityTrustHtml(mainContent.textarea);
      this.currentButtonLabel = mainContent.label || 'Continue';
      this.currentButtonStyle = mainContent.btn_style || 'btn-primary';
      this.acceptanceLabel = mainContent.agreement_checkbox_label;

      if (!this.acceptanceLabel || this.acceptanceLabel.trim() === '') {
        this.isAgreed = true;
      }
    } else {
      if (this.multistepData.multisteps && this.multistepData.multisteps[stepNumber]) {
        const stepContent = this.multistepData.multisteps[stepNumber];
        this.currentContent = this.sanitizer.bypassSecurityTrustHtml(stepContent.textarea);
        this.currentButtonLabel = stepContent.label || 'Continue';
        this.currentButtonStyle = stepContent.btn_style || 'btn-primary';
        this.acceptanceLabel = stepContent.agreement_checkbox_label;

        if (!this.acceptanceLabel || this.acceptanceLabel.trim() === '') {
          this.isAgreed = true;
        }
      } else {
        const mainContent = this.multistepData.main_content;
        this.currentContent = this.sanitizer.bypassSecurityTrustHtml(mainContent.textarea);
        this.currentButtonLabel = mainContent.label || 'Continue';
        this.currentButtonStyle = mainContent.btn_style || 'btn-primary';
        this.acceptanceLabel = mainContent.agreement_checkbox_label;

        if (!this.acceptanceLabel || this.acceptanceLabel.trim() === '') {
          this.isAgreed = true;
        }
      }
    }

    this.currentStep = stepNumber;
  }

  nextStep() {
    if (this.totalSteps === 0) {
      this.finishAndGo();
      return;
    }

    if (this.currentStep === 0) {
      this.loadStep(1);
    } else if (this.currentStep < this.totalSteps) {
      this.loadStep(this.currentStep + 1);
    } else {
      this.finishAndGo();
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.loadStep(this.currentStep - 1);
    } else if (this.currentStep === 1) {
      this.loadStep(0);
    }
  }
}


